import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import RadioList, { RadioListItem } from './RadioList';

interface Props extends BaseFieldProps {
	options: RadioListItem[];
	value?: string | number | boolean;
	onChange?: (value: string | number | boolean) => void;
	inLine?: boolean;
}

const RadioListField: React.FC<Props> = props => {
	return (
		<BaseField {...props}>
			<RadioList
				options={props.options}
				value={props.value}
				onChange={props.onChange}
				inLine={props.inLine}
			/>
		</BaseField>
	);
};

export default RadioListField;
